/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import BenefitsService from 'src/services/benefits.service';
import { IBenefitsConfigVersion } from 'src/interfaces';

export const useDuplicateBenefitsConfigVersionWithData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IBenefitsConfigVersion & { originalId: string }) =>
      BenefitsService.duplicateBenefitsConfigVersionWithData(data.originalId, data),
    onSuccess: () => {
      // Invalidate and refetch the benefits config version query
      queryClient.invalidateQueries({ queryKey: ['benefits-config-version'] });
    },
  });
};
